export default "__VITE_ASSET__CTYGMjGl__"